import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, useEffect, useState } from 'react';
import { allRules } from 'utils/validation';
import withErrorBoundary from 'components/ui/withErrorBoundaries';

interface TimePickerProps {
  value?: Date;
  onChange: (value: Date) => void;
  hoursStep?: number;
  minutesStep?: number;
}

const TimePicker: FC<TimePickerProps> = ({ hoursStep = 1, minutesStep = 10, ...props }) => {
  const [hours, setHours] = useState<number>(0);
  const [minutes, setMinutes] = useState<number>(0);

  useEffect(() => {
    const newHours = props.value?.getHours();
    const newMinutes = props.value?.getMinutes();

    if (typeof newHours === 'number' && typeof newMinutes === 'number') {
      setHours(newHours);
      setMinutes(newMinutes);
    }
  }, [props.value]);

  const changeHours = (value: number) => {
    let newHours = 0;
    if (value > 23) {
      newHours = 0;
    } else if (value < 0) {
      newHours = 23;
    } else if (allRules.numbers.test(value.toString())) {
      newHours = value;
    }

    setHours(newHours);
    props.onChange(new Date(props.value?.setHours(newHours) as number));
  };

  const changeMinutes = (value: number) => {
    let newMinutes = 0;
    if (value > 59) {
      newMinutes = 0;
      changeHours(hours + 1);
    } else if (value < 0) {
      newMinutes = 50;
      changeHours(hours - 1);
    } else if (allRules.numbers.test(value.toString())) {
      newMinutes = value;
    }
    setMinutes(newMinutes);
    props.onChange(new Date(props.value?.setMinutes(newMinutes) as number));
  };

  return (
    <div className="time-picker">
      <div className="time-picker-col">
        <FontAwesomeIcon icon={faChevronUp} onClick={() => changeHours(hours + hoursStep)} />
        <input value={hours} onChange={(e) => changeHours(+e.target.value)} />
        <FontAwesomeIcon icon={faChevronDown} onClick={() => changeHours(hours - hoursStep)} />
      </div>
      <div className="time-picker-divider">:</div>
      <div className="time-picker-col">
        <FontAwesomeIcon icon={faChevronUp} onClick={() => changeMinutes(minutes + minutesStep)} />
        <input value={minutes} onChange={(e) => changeMinutes(+e.target.value)} />
        <FontAwesomeIcon
          icon={faChevronDown}
          onClick={() => changeMinutes(minutes - minutesStep)}
        />
      </div>
    </div>
  );
};

export default withErrorBoundary(TimePicker, 'TimePicker');
